import { memo, useContext } from "react";
import { Data } from "./App";
import styles from "./App.module.scss";

const InputText = memo(({ label, name, max, placeholder, require }) => {
  const { inputs, setInputs, errors, setErrors } = useContext(Data);

  const onChange = (e) => {
    setInputs({ ...inputs, [name]: e.target.value });
    if (require && e.target.value.length === 0) {
      setErrors({ ...errors, [name]: "*必須" });
    } else if (e.target.value.length > max) {
      setErrors({ ...errors, [name]: max + "文字以内でご入力ください" });
    } else {
      setErrors({ ...errors, [name]: null });
    }
  };

  return (
    <label className={styles.labelCommon}>
      <p className="bold">
        {label}
        <span>{errors[name]}</span>
      </p>
      <input
        type="text"
        name={name}
        value={inputs[name]}
        onChange={onChange}
        placeholder={placeholder}
      />
    </label>
  );
});

export default InputText;
